/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { EvaluationState } from './EvaluationState';
import {
    instanceOfEvaluationState,
    EvaluationStateFromJSON,
    EvaluationStateFromJSONTyped,
    EvaluationStateToJSON,
} from './EvaluationState';

/**
 * @type BeamConstancyWorkResultDtoOutput
 * 
 * @export
 */
export type BeamConstancyWorkResultDtoOutput = EvaluationState;


export function BeamConstancyWorkResultDtoOutputFromJSON(json: any): BeamConstancyWorkResultDtoOutput {
    return BeamConstancyWorkResultDtoOutputFromJSONTyped(json, false);
}

export function BeamConstancyWorkResultDtoOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): BeamConstancyWorkResultDtoOutput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    // This is the original code, had to remove spread operator for const object enums that are not spreadable
    // return { ...EvaluationStateFromJSONTyped(json, true) };
    return  EvaluationStateFromJSONTyped(json, true);
}

export function BeamConstancyWorkResultDtoOutputToJSON(value?: BeamConstancyWorkResultDtoOutput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfEvaluationState(value)) {
        return EvaluationStateToJSON(value as EvaluationState);
    }

    return {};
}

/**
 * Check if a given object implements the BeamConstancyWorkResultDtoOutput interface.
 */
export function instanceOfBeamConstancyWorkResultDtoOutput(value: any): value is BeamConstancyWorkResultDtoOutput {
    if (instanceOfEvaluationState(value)) return true;
    return false;
}

